import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Send, FileText, ArrowRight } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { brl, dateBR } from "../../lib/format";
import { Card } from "../common";
import { Button } from "../ui/button";
import { FinPill, lateText } from "./FinPill";

export function FinanceAlerts({ alerts, onCharge, onChanged }) {
  if (!alerts.length) return null;
  const send = async (a) => { try { const { data } = await api.post(`/finance/invoices/${a.invoice_id}/send`); toast.success(`Cobrança enviada para ${data.sent_to.join(", ")}`); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Card className="p-4" testid="fin-alerts">
      <div className="text-sm font-semibold flex items-center gap-2"><BellRing className="h-4 w-4 text-amber-600" />Precisam de atenção <span className="text-slate-400 font-normal">· {alerts.length}</span></div>
      <div className="mt-3 divide-y">
        {alerts.map((a) => (
          <div key={a.invoice_id} className="py-2.5 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm" data-testid={`fin-alert-${a.invoice_id}`}>
            <div className="min-w-[200px] flex-1"><div className="font-medium">{a.days === 3 ? `Fatura da ${a.trade_name} vence em 3 dias.` : a.trade_name}</div>
              <div className="text-xs text-slate-500">Vencimento {dateBR(a.due_date)} · <b className="text-slate-700">{brl(a.total_amount)}</b> · {a.payment_method}{a.sent_at ? " · cobrança enviada" : ""} · {lateText(a.days)}</div></div>
            <FinPill s={a.status} testid={`fin-alert-status-${a.invoice_id}`} />
            <div className="flex gap-2">
              <Button size="sm" variant="outline" onClick={() => onCharge(a.invoice)} data-testid={`fin-alert-charge-${a.invoice_id}`}><FileText className="h-3.5 w-3.5 mr-1" />{a.has_charge ? "Cobrança" : "Gerar/registrar cobrança"}</Button>
              <Button size="sm" variant="outline" onClick={() => send(a)} data-testid={`fin-alert-send-${a.invoice_id}`}><Send className="h-3.5 w-3.5 mr-1" />Enviar cobrança</Button>
              <Button size="sm" variant="ghost" asChild><Link to={`/backoffice/financeiro/${a.company_id}`} data-testid={`fin-alert-open-${a.invoice_id}`}>Ver cliente<ArrowRight className="h-3.5 w-3.5 ml-1" /></Link></Button>
            </div>
          </div>))}
      </div>
    </Card>);
}
